import { Component, OnInit } from "@angular/core";

@Component({
  selector: "app-navbar",
  templateUrl: "./navbar.component.html",
  styleUrls: ["./navbar.component.scss"],
})
export class NavbarComponent implements OnInit {
  constructor() {}

  ngOnInit() {}

  // Method to redirect to external login page
  redirectToLogin() {
    window.location.href = "https://djqj6mmx7fq07.cloudfront.net";
  }
}
